import featureFlagConfig from '@/projectConfig/featureFlagConfig';
import { getCresivoxBaseUrl } from '@/projectConfig/cresivoxBaseUrl';

/**
 * @description
 * Environment variables used in the application
 */
const env = {
  CRESIVOX_BASE_URL: getCresivoxBaseUrl(),
  ONECLICK_API_SERVER_TIMEOUT: process.env.NEXT_PUBLIC_ONECLICK_API_SERVER_TIMEOUT,
  FEATURE_FLAG_CONFIG: featureFlagConfig,
};

export default env;
